export default __webpack_public_path__ + "static/media/heroImage.60d79e2c.png";